"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Stack_Item_1 = __importDefault(require("./Stack.Item"));
require("./Stack.css");
var Stack = function Stack(_a) {
    var children = _a.children, _b = _a.justify, justify = _b === void 0 ? "flex-start" : _b, _c = _a.align, align = _c === void 0 ? "center" : _c, _d = _a.spacing, spacing = _d === void 0 ? "base" : _d, _e = _a.column, column = _e === void 0 ? false : _e, _f = _a.wrap, wrap = _f === void 0 ? false : _f;
    var mainClass = React.useMemo(function () {
        return (0, classnames_1.default)("nimbus--stack-wrapper", "justify-content--".concat(justify), "align-items--".concat(align), "spacing--".concat(spacing), { "stack--column": column }, { "stack--wrap": wrap });
    }, [justify, spacing, align, column, wrap]);
    return React.createElement("div", { className: mainClass }, children);
};
Stack.Item = Stack_Item_1.default;
exports.default = Stack;
//# sourceMappingURL=index.js.map